import React, { useRef, useState } from "react";
import { Observer, observer } from "mobx-react-lite";
import Tabs from "../../components/Tabs";
import ScrollDataTable from "../../components/Table/ScrollDataTable";
import { defaultTransactionSortConfig } from "../../utils/constants";
import loaderGIF from "../../assets/images/gifs/loaderGIF.gif";
import taxlotsEmpty from "../../assets/images/svg/taxlotsEmpty.svg";

const EmptyState = (tab) => {
  const [isLoading, setIsLoading] = useState(true);
  setTimeout(() => {
    setIsLoading(false);
  }, 100);

  return (
    <>
      {!isLoading ? (
        <div
          style={{
            marginTop: "11px",
            minHeight: "342px",
          }}
          className="tax_lots_empty flex is-justify-content-center is-align-items-center is-fullheight is-flex-direction-column"
        >
          <div className="empty_state_img_wrapper">
            <img width="100%" src={taxlotsEmpty} alt="transaction icon" />
          </div>
          <div className="empty_state_txt">
            {`You do not have any Transactions to Report`}
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </>
  );
};

const OffshoreTransactions = ({
  isLoading,
  columns,
  transactions,
  instrument,
}) => {
  const [selectedTab, setTab] = useState("transactions");
  const [sortingConfig, setSortingConfig] = useState({
    ...defaultTransactionSortConfig,
  });

  const tablesRef = useRef(null);
  const transactionRef = useRef(null);

  return (
    <Observer>
      {() => (
        <>
          <div className="snapshot_content">
            {isLoading ? (
              <div className="ledger_popup_loader">
                <div style={{ height: "61px" }} className="modal_header">
                  <p className="modal_heading">{""}</p>
                </div>
                <img className="loader_gif" src={loaderGIF} alt="loading..." />
              </div>
            ) : (
              <div className="instru_det_outside" style={{ paddingTop: "0px" }}>
                <div className="modal_header portfolioModal">
                  <p className="modal_heading instru_det_title">
                    {instrument?.details?.instrument_name}
                  </p>
                </div>

                <div
                  className={
                    "snapshot_table_bg margin_for_instrument flex_class"
                  }
                >
                  <div className="tabsNTableWrapper">
                    <div className="tabs_wrapper">
                      <Tabs
                        onSelect={(value) => {
                          setTab(value);
                        }}
                        classN={"modal_Tab"}
                        tabs={[
                          {
                            label: "Transactions",
                            value: "transactions",
                          },
                        ]}
                      />
                    </div>

                    {selectedTab === "transactions" && !!transactions && (
                      <div
                        ref={tablesRef}
                        className={"normal_table_wrapper"}
                        onScroll={(e) => {
                          transactionRef.current.handleScrollStart(e, "");
                        }}
                      >
                        <ScrollDataTable
                          ref={transactionRef}
                          tableData={transactions}
                          columns={columns}
                          tableClass="equity_summary_table_transac inModal"
                          EmptyState={() => EmptyState(selectedTab)}
                          sortingConfig={sortingConfig}
                          setSortingConfig={(data) => {
                            tablesRef.current.scrollTop = 0;
                            setSortingConfig(data);
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </Observer>
  );
};

export default observer(OffshoreTransactions);
